import { faArrowRight, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import auth from '../../firebase.init';
import Loading from '../../Shared/Loading';

const AboutMeUpdate = () => {


    const [aboutMeImg, setAboutMeImg] = useState('');

    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const imgStoreKey = '1102b1b472176018cfdab59d9d885956';


    const [user, loading] = useAuthState(auth);

    if (loading) {
        return <Loading />
    }

    const onSubmitImage = data => {
        const imges = data.aboutmephoto[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setAboutMeImg(data?.data?.url);
                    toast.success('About Me Photo Added!!')
                }
            })
    }


    const onSubmitForm = data => {
        const updatedAboutMe = {
            myself: data?.myself,
            myhobbies: data?.myhobbies,
            img: aboutMeImg
        }


        const url = `https://stark-wildwood-35883.herokuapp.com/aboutme/${user?.email}`
        fetch(url, {
            method: "PUT",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(updatedAboutMe)
        })
            .then(res => res.json())
            .then(data => {
                if (data?.modifiedCount > 0) {
                    toast.success('About Me Update Successfully!!!');
                    reset();
                }
            })
    }



    return (
        <div className='bg-slate-200 px-8 py-10 md:h-screen md:p-6 h-screen'>
            <div className='grid md:grid-cols-2 grid-cols-1  gap-6'>
                <div>
                    <form onSubmit={handleSubmit(onSubmitImage)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <label className="label font-semibold  lg:text-lg md:text-medium">About Me Photo</label>
                            <input
                                type="file"
                                placeholder="Banner Photo"
                                className="input input-bordered w-full cursor-pointer   "
                                {...register("servicePhoto", {
                                    required: {
                                        value: true,
                                        message: " About Me Photo is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.aboutmephoto?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.aboutmephoto?.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 border-0 text-white'> Add Photo <FontAwesomeIcon className='ml-2' icon={faImage} /> </button>
                        </div>
                    </form>
                </div>
                <div>
                    <form onSubmit={handleSubmit(onSubmitForm)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <h2 className='text-2xl font-bold text-green-500 text-center py-3'>Update About Me</h2>

                            <label className="label font-semibold lg:text-lg md:text-medium ">About Myself</label>
                            <textarea
                                type="text"
                                placeholder="About Myself"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered  "
                                {...register("myself", {
                                    required: {
                                        value: true,
                                        message: "About Myself is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.myself?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.myself?.message}</span>}
                            </label>

                            <label className="label font-semibold lg:text-lg md:text-medium">My Starting and Hobbies</label>
                            <textarea
                                type="text"
                                placeholder="My Starting and Hobbies"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered  "
                                {...register("myhobbies", {
                                    required: {
                                        value: true,
                                        message: "My Starting and Hobbies is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.myhobbies?.type === 'required' && <span className="label-text-alt text-red-500">{errors.myhobbies.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 mt-2 border-0 text-white'> Update About Me <FontAwesomeIcon className='ml-2' icon={faArrowRight} /> </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AboutMeUpdate;